import { ITenure } from "src/domain/entities"
import { tenureListApi } from "../../api/tenure/tenureListApi"

type PayloadShape = Parameters<typeof tenureListApi>[0]

export async function tenureListService(payload: PayloadShape, token?: null | string) {
	const tenure = await tenureListApi(payload, token)
	return tenure as NonNullable<ITenure[]>
}
